import * as React from "react";
function SvgBang(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <circle cx={16} cy={29} r={3} />
      <path d="M13.25 2.75a2.75 2.75 0 015.5 0c0 1.52-1.37 17.12-1.37 17.88a1.38 1.38 0 01-2.75 0c0-.76-1.38-16.36-1.38-17.88z" />
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgBang);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
